import { HStack, Text } from '@chakra-ui/react';
import { LoadingIndicator } from './LoadingIndicator';

/** Keep this slot mounted so a refresh never changes the header's geometry. */
export function RefreshStatus({
  active,
  label = 'Updating…',
}: {
  active: boolean;
  label?: string;
}) {
  return (
    <HStack
      data-loading-refresh={active ? 'true' : 'false'}
      visibility={active ? 'visible' : 'hidden'}
      aria-hidden={!active || undefined}
      role={active ? 'status' : undefined}
      gap="2"
      minH="5"
      flexShrink={0}
    >
      <LoadingIndicator size="xs" decorative />
      <Text fontSize="xs" color="ui.text.tertiary" whiteSpace="nowrap">
        {label}
      </Text>
    </HStack>
  );
}
